/* import __COLOCATED_TEMPLATE__ from './consent.hbs'; */
import Component from '@glimmer/component';
export default class Consent extends Component {}